//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BannerCard",
  props: {
    banner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
}
